import React from "react";
import {compose} from "redux";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {Image, ScrollView, StyleSheet, Text, TouchableOpacity, View} from "react-native";
import WebView from "react-native-webview";
import ChevronDroitMediumPicto from "../Picto/ChevronDroitMediumPicto";
import CheckActivePicto from "../Picto/CheckActivePicto";
import MyTheme from "../../Theme/Theme";
import FilePicto from "../Picto/FilePicto";
import {getAppConfigJsonValue} from "../../API/API";

import { setLocale } from "react-redux-i18n";

class File extends React.Component {
  constructor(props) {
    super(props);
    this.download = this.download.bind(this);
    this.state = {
      downloadUrl: undefined
    }
  }
  download() {
    this.setState({downloadUrl: this.props.file.url });
  }
  render() {
    let name = this.props.file.name;

    const styles = StyleSheet.create({

	fileContainer:{
	    flexDirection:"row",
	    justifyContent:"space-between",
            backgroundColor:this.props.theme.colors.primary.White.value
	    // backgroundColor: this.props.theme.colors.primary.blue5.value,
	    // borderRadius:5,
	    // marginVertical:3,
	},
	pictoFileContainer:{
	    flexDirection:"row",
	    justifyContent:"center",
	    alignItems:"center",
	},
	picto:{
	    marginVertical:5,
	    marginHorizontal:15
	},
	fileName : {
	    fontFamily : this.props.theme.fonts.text,
	    fontSize: 14,
	    color : this.props.theme.colors.primary.blue1.value,
	}
    });

    return <View>
      <TouchableOpacity onPress={this.download.bind(this)}>
      <View style={styles.fileContainer}>
	<View style={styles.pictoFileContainer}>
	  <FilePicto style={[styles.picto,{width:19}]} isHeader={true}></FilePicto>
	  <Text style={styles.fileName}>{name}</Text>
	</View>
      </View>
      </TouchableOpacity>
    { this.state.downloadUrl != undefined && <WebView style={{width:0,height:0}}  source={{ uri: this.state.downloadUrl }} /> }
    </View>
  }
}

class ReglageCGU extends React.Component{
    constructor(props) {
      super(props);
      this.state = {
	loading: true,
	cgu: null
      };
    }

    componentDidMount() {
      this._setHeader();
      getAppConfigJsonValue("cgu").then((cgu) => {
	this.setState({loading: false, cgu})
      })
    }

    // ?
    componentDidUpdate() {
      this._setHeader();
    }

    _setHeader(){
        const styleHeaderGlobalWhite = {
            fontFamily: this.props.theme.fonts.title,
            backgroundColor : this.props.theme.colors.primary.White.value,
            height:80
        }  ;
        this.props.navigation.setOptions(
            {
                headerTitleAlign: "center",
                headerStyle: styleHeaderGlobalWhite,
                headerTitleStyle:{textTransform: 'capitalize'},
                title : this.props.t('GCU'),
                headerLeft : ()=><TouchableOpacity onPress={this.props.navigation.goBack}>
                    <Image resizeMode={"contain"} style={{width:20,height: 20,marginLeft:20, flex: 1}} source={this.props.theme.pictos.chevronGaucheMediumPicto.light} />
                </TouchableOpacity>
            }
        );
    }

    render() {
	const { t, theme } = this.props;
	const { cgu, loading } = this.state;

        const styles= StyleSheet.create({
            container:{
                paddingVertical:12,
                paddingHorizontal:20,
                flexDirection:"row",
                justifyContent:"space-between",
                alignItems:"center",
                borderBottomWidth:1,
                borderBottomColor:this.props.theme.colors.tertiary.black13.value,
                backgroundColor:this.props.theme.colors.primary.White.value
            } ,
            container_title:{
                backgroundColor:this.props.theme.colors.primary.blue5.value,
                color:this.props.theme.colors.primary.blue1.value
            },
            text:{
                fontFamily:this.props.theme.fonts.text_bold,
                color : this.props.theme.colors.tertiary.black3.value,
                fontSize:15,
                fontWeight:500
            },
            text_title:{
                color:this.props.theme.colors.primary.blue1.value
            },
            picto:{
                width:10,
                marginRight:10
            }
        });

        return <ScrollView>
	  <TouchableOpacity>
	    <View style={[styles.container,styles.container_title]}>
	      <Text style={[styles.text,styles.text_title]}>{this.props.t("General Conditions of Use")}</Text>
	    </View>
	  </TouchableOpacity>
	  {
	    loading == false && cgu.last_version_at === null &&
	    <View style={styles.container}>
	      <Text style={styles.text}>{ t("No GCU") }</Text>
            </View>
	  }

	  { loading === false && cgu.last_version_at && <File file={{url: "/app_config/file/cgu/fr", name: cgu.pdf_fr}} theme={theme} />}
	  { loading === false && cgu.last_version_at && <File file={{url: "/app_config/file/cgu/en", name: cgu.pdf_en}} theme={theme} />}
	</ScrollView>
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default compose(connect(mapStateToProps),withTranslation())(ReglageCGU);

